import { Link as TsLink } from '@tanstack/react-router'
import React from 'react'

type Props = {
    href?: string | { pathname?: string; query?: any }
    to?: string
    children?: React.ReactNode
    // Next.js-only props
    as?: string | { pathname?: string; query?: any }
    passHref?: boolean
    prefetch?: boolean
    replace?: boolean
    scroll?: boolean
    shallow?: boolean
    locale?: string | false
    [key: string]: any
}

// Helper to resolve Next.js-style url/as to a string path
const resolveHref = (url: any, as?: any) => {
    const dest = as || url
    if (typeof dest === 'string') return dest
    if (!dest) return '#'

    let path = dest.pathname ?? '/'
    if (dest.query) {
        const params = new URLSearchParams()
        Object.entries(dest.query).forEach(([k, v]) => {
            if (Array.isArray(v)) {
                v.forEach(val => params.append(k, String(val)))
            } else if (v !== undefined && v !== null) {
                params.append(k, String(v))
            }
        })
        const qs = params.toString()
        if (qs) path += (path.includes('?') ? '&' : '?') + qs
    }
    return path
}

export default function Link({ href, to, as, passHref: _p, prefetch: _pf, replace, scroll: _sc, shallow: _sh, locale: _l, children, ...props }: Props) {
    const dest = resolveHref(to ?? href, as)
    // External URLs, anchors, and protocol links bypass the router
    if (/^(https?:\/\/|\/\/|mailto:|tel:)/.test(dest)) {
        return <a href={dest} {...props}>{children}</a>
    }
    return <TsLink to={dest as any} replace={replace} {...props}>{children}</TsLink>
}
